import { tWithKeyAttr as t } from "../../i18nHelper";
import chatSidebarStyles from "./chatSidebar.module.css";
import React, { Dispatch, SetStateAction, useState } from "react";
import defaultAvatar from "../../images/default_avatar.png";
import { useAppSelector } from "../../services/hooks";
import CloseChatButton from "../closeChatButton/closeChatButton";
import { chatUsersSelector } from "../../services/selectors/chat.selector";
import { IConversation } from "../../services/types";
import i18n from "../../i18n";

interface ChatSideBarProps {
  activeUser: undefined | IConversation;
  setActiveUser: Dispatch<SetStateAction<undefined | IConversation>>;
  setOpenSideBar?: Dispatch<SetStateAction<boolean>>;
  openMenu: boolean;
}

const ChatSideBar: React.FC<ChatSideBarProps> = ({
  activeUser,
  setActiveUser,
  openMenu,
  setOpenSideBar,
}) => {
  const chatUsers = useAppSelector(chatUsersSelector);
  const [showActiveAppointments, setShowActiveAppointments] = useState(true);
  const [searchTherapist, setSearchTherapist] = useState<string>("");

  const filteredUsers = chatUsers
    .filter((u) => (showActiveAppointments ? u.active : !u.active))
    .filter((u) => {
      if (!u || !u.fullName) {
        return false; 
      }
      return u.fullName.toLowerCase().includes(searchTherapist.toLowerCase().trim());
    });  

  return (
    <section
      className={`${chatSidebarStyles.sidebar} ${!openMenu && chatSidebarStyles.sidebar_closed}`}
               dir={i18n.dir()}
    >
      <div className={chatSidebarStyles.sidebar__buttons}>
        <button
          className={`${chatSidebarStyles.sidebar__btn} ${!showActiveAppointments && chatSidebarStyles.sidebar__btn_active}`}
          onClick={() => setShowActiveAppointments(false)}
        >
          {t("CHAT_SIDEBAR_ARCHIVE")}
        </button>
        <button
          className={`${chatSidebarStyles.sidebar__btn} ${showActiveAppointments && chatSidebarStyles.sidebar__btn_active}`}
          onClick={() => setShowActiveAppointments(true)}
        >
          {t("CHAT_SIDEBAR_CALLS")}
        </button>
      </div>
      <section className={chatSidebarStyles.pageWrapper}>
        <input
          type="text"
          placeholder={t("CHAT_SIDEBAR_SEARCH_PLACEHOLDER")}
          value={searchTherapist}
          onChange={(e) => setSearchTherapist(e.target.value)}
          className={chatSidebarStyles.sidebar__input}
        />

        {filteredUsers.length === 0 ? (
          <p className={chatSidebarStyles.chatListEmpty}>
            {chatUsers.length === 0
              ? t("CHAT_SIDEBAR_NO_CHATS")
              : t("CHAT_SIDEBAR_NO_SEARCH_RESULTS")}
          </p>
        ) : (
          <ul
            className={`${chatSidebarStyles.sidebar__therapists} ${chatSidebarStyles.scrollable} scroll`}
          >
            {filteredUsers.map((u) => {
              const hasUnread = (u.messages ?? []).some(
                (msg) => msg.unRead === 1
              );
              return (
                <li
                  key={u.userId}
                  className={`${chatSidebarStyles.sidebar__li} ${u.userId === activeUser?.userId &&
                    chatSidebarStyles.sidebar__li_active}`}
                  onClick={() => {
                    setActiveUser(u);
                    if (setOpenSideBar) setOpenSideBar(false);
                  }}
                >
                  <div
                    data-testid="status-indicator"
                    className={`${chatSidebarStyles.sidebar__online} ${u.online && chatSidebarStyles.sidebar__online_active}`}
                  >
                    <img
                      className={chatSidebarStyles.sidebar__avatar}
                      src={defaultAvatar}
                      alt={u.fullName}
                    />
                    {(u.online && u.userId !== activeUser?.userId) && hasUnread && (
                      <span
                        data-testid="unread-indicator"
                        className={chatSidebarStyles.sidebar__onlinePlus}
                      >
                        +
                      </span>
                    )}
                  </div>
                  <div className={chatSidebarStyles.sidebar__therapist}>
                    <p className={chatSidebarStyles.sidebar__name} data-testid="therapist-name">
                      {u.fullName}
                    </p>
                  </div>
                  {u.appointment && u.appointment.active && (
                    <CloseChatButton appointment={u.appointment} />
                  )}
                </li>
              );
            })}
          </ul>
        )}
      </section>
    </section>
  );
};

export default ChatSideBar;